// extracted by mini-css-extract-plugin
export var avatarContainer = "_ai-0";
export var avatarTypingWave = "_ai-i";
export var gray = "_ai-f";
export var green = "_ai-c";
export var icon = "_ai-9";
export var image = "_ai-1";
export var lg = "_ai-6";
export var md = "_ai-5";
export var presenceDot = "_ai-b";
export var red = "_ai-d";
export var sm = "_ai-4";
export var status = "_ai-a";
export var typingDot = "_ai-h";
export var typingPill = "_ai-g";
export var xl = "_ai-7";
export var xs = "_ai-3";
export var xxl = "_ai-8";
export var xxs = "_ai-2";
export var yellow = "_ai-e";